import { removeItemFromArray } from './arrayFunctions';

// eslint-disable-next-line import/prefer-default-export
export const isEmptyObject = (obj) => {
    if (!obj || Array.isArray(obj)) return false;
    return !(Object.keys(obj).length > 0);
};

export const isValidObject = (obj) => {
    if (!obj) return false;
    if (typeof obj !== 'object') return false;
    if (typeof obj === 'object' && Array.isArray(obj)) return false;
    return Object.keys(obj).length > 0 ? obj : {};
};

export const returnFiltersQueryString = (obj) => {
    const arr = [];
    Object.keys(obj).forEach((objKey) => {
        const filterTypeObj = obj[objKey];

        let str = '';
        const filterTypeObjArr = Object.keys(filterTypeObj);
        // const isDateFilterIndex = filterTypeObjArr.indexOf('isDateFilter');
        if ('isDateFilter' in filterTypeObj) {
            // deleteObj(filterTypeObj, 'isDateFilter');
            // delete filterTypeObj.isDateFilter;
            const finalFilterObj = {};
            // for (const key in filterTypeObj) {
            //     if (key !== 'isDateFilter') finalFilterObj[key] = filterTypeObj[key];
            // }
            const finalFilterObjArr = removeItemFromArray(filterTypeObjArr, 'isDateFilter');
            finalFilterObjArr.forEach((item, i) => {
                finalFilterObj[item] = filterTypeObj[item];
            });
            // const finalFilterVal = Object.values(finalFilterObj).join('__');

            const dateRangeValue = Object.values(finalFilterObj).join('__');

            // const dateStr = `${objKey}start_date=${dateRangeValue}`;
            const dateStr = `${objKey}__range=${dateRangeValue}`;
            // start_date=2022-02-01&end_date=2022-09-28
            arr.push(dateStr);
        } else {
            filterTypeObjArr.forEach((filterTypeObjkey) => {
                if (objKey === 'ontrip_live' || objKey === 'vip_traveller') {
                    const value = filterTypeObj[filterTypeObjkey]?.id !== 0;
                    str = `${objKey}=${value}`;
                    arr.push(str);
                } else {
                    const value = filterTypeObj[filterTypeObjkey]?.id;
                    str = `${objKey}=${value}`;
                    arr.push(str);
                }
            });
        }
    });

    return arr.join('&');
};

export const filterQueryString = (obj) => {
    // console.log('filterType filterQueryString', obj);
    const arr = [];
    Object.keys(obj).forEach((objKey) => {
        const filterTypeObj = obj[objKey];
        let str = '';
        const filterTypeObjArr = Object.keys(filterTypeObj);
        // console.log('filterType filterTypeObjArr', filterTypeObjArr);

        if ('isDateFilter' in filterTypeObj) {
            const finalFilterObj = {};
            const finalFilterObjArr = removeItemFromArray(filterTypeObjArr, 'isDateFilter');
            // console.log('finalFilterObjArr ', finalFilterObjArr);
            finalFilterObjArr.forEach((item, i) => {
                finalFilterObj[item] = filterTypeObj[item];
            });

            const startDate = `start_date=${finalFilterObj.start_date}`;
            const endDate = `end_date=${finalFilterObj.end_date}`;
            console.log('date arr', startDate, endDate);
            const dateStr = startDate.concat('&', endDate);
            console.log('date str test', dateStr);
            arr.push(dateStr);
        } else {
            filterTypeObjArr.forEach((filterTypeObjkey) => {
                const value = filterTypeObj[filterTypeObjkey]?.id;
                // console.log('filterTypeObjkey query ', value, filterTypeObjkey);
                str = `${objKey}=${value}`;
                arr.push(str);
            });
        }
    });

    return arr.join('&');
};

export const queryStringToObj = (queryString) => {
    if (queryString) {
        // let searchParams = new URLSearchParams(location.search);
        queryString = queryString.substring(1);
        if (queryString[0] === '&') {
            queryString = queryString.substring(1);
        }
        const searchObjString = `{"${decodeURI(queryString).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"')}"}`;
        // '{"' + decodeURI(queryString).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g,'":"') + '"}';
        let result = {};
        try {
            result = JSON.parse(searchObjString);
        } catch (e) {
            console.log('searchParams error ', e, searchObjString);
            console.log(JSON.stringify(searchObjString));
            return {}; // null
        }
        return JSON.parse(searchObjString);
    }
    return {};
};

export const getFilterTypeOptions = (id, filters) => {
    let arr = [];
    // eslint-disable-next-line array-callback-return, consistent-return
    filters.forEach((filterTypeObj) => {
        const [firstKey] = Object.keys(filterTypeObj);
        if (id === firstKey) {
            arr = [...filterTypeObj[firstKey]];
        }
    });
    return arr;
};

export const getTypeIdByName = ({ value = '', typeOptions = [], key = '', labelKey = '' }) => {
    const typeOption = typeOptions.find((option) => option[key]);
    // key - sent to formik values (payload)
    // labelKey - shown on UI
    if (typeOption && typeOption[key]) {
        const type = typeOption[key].find((item) => item[labelKey] === value);
        if (type) {
            return type.id;
        }
    }
    return null;
};

export const getObjById = (id, options = []) => {
    if (!options?.length > 0) return {};
    const obj = options.find((item) => item.id === id);
    return obj;
};
